import { Controller } from 'react-hook-form';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import { es } from 'date-fns/locale';
import { FaCalendar } from 'react-icons/fa';
import PropTypes from 'prop-types';
import {setTipoMovilidadCaract} from './../../Utils/SetTipoMovilidadCaract';

registerLocale('es', es);
setDefaultLocale('es');
export default function DesplazamientoForzado(
    props,
) {
   
    const { register, 
        watch,
        setValue,
        control, 
        errors, 
        forwardRef, 
        numedesplazamientos,
        municipiosdto,
        tiposlugar,
        tiposDesplazamiento,
        tiposMovilidad,
        causasDesplazamiento,
        responsableDesplazamiento,
        causasDesplazamientoSeleccionadas,
        responsableDesplazamientoSeleccionados,
        ActualizarCausasDesplazamiento,
        ActualizarActoresArmados,
        hechosVictimizantes,  } = props;

    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
            ref={ref}
            tabIndex={0}
            aria-label="Seleccionar fecha"
            style={{ display: 'flex', alignItems: 'center', background: 'none', border: '1px solid #ced4da', padding: 2, cursor: 'pointer' }}
        >
            <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }}/>
            <FaCalendar size={20} color="black" />
        </button>
        ));

    return (
        <div>
            <div hidden className="row">
                <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="regNumdesplazamientoid">Cu&aacute;ntos desplazamientos forzados tiene el hogar?</label>
                        <select id="regNumdesplazamientoid" {...register('regNumdesplazamientoid', { required: true })} className="form-control">
                            {(Array.isArray(numedesplazamientos) ? numedesplazamientos : []).map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.numDesplazamiento}
                                </option>
                            ))}
                        </select>
                        {errors.regNumdesplazamientoid && <p style={{ color: 'red' }}>Seleccione numero desplazamiento</p>}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <div className="form-group" >
                        <label htmlFor="tipoHecho">Tipo hecho?</label>
                        <select id="tipoHecho" {...register('tipoHecho', { required : true})} className='form-control' >
                            <option value="">Seleccionar</option>
                            {hechosVictimizantes.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.hecHecho}
                            </option>
                            ))}
                        </select>
                        {errors.tipoHecho && <p style={{color: 'red'}}>Seleccione tipo hecho</p>}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <div className="form-group">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <label htmlFor="fechaDesplazamiento">Fecha del hecho:</label>
                            <Controller
                                control={control}
                                id="fechaDesplazamiento" name="fechaDesplazamiento"
                                render={({ field }) => (
                                    <DatePicker
                                        placeholderText="fecha"
                                        onChange={(date) => field.onChange(date)}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        selected={field.value}
                                        customInput={<CustomInput />}
                                        locale="es"
                                        dateFormat="yyyy-MM-dd"
                                        maxDate={new Date()}
                                    />
                                )}
                            />
                            {errors.fechaDesplazamiento && <p style={{ color: 'red' }}>Digite fecha desplazamiento</p>}
                        </div>
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="form-group">
                        <label htmlFor="municipioDesplazamiento">Municipio del hecho</label>
                        <select 
                            id="municipioDesplazamiento" 
                            {...register('municipioDesplazamiento', { required: true })} 
                            onChange={(e) => {
                                const selectedMunicipio = e.target.value.toString();
                                const selectedDepartamento = municipiosdto.find(m => m.id === selectedMunicipio).mun_departamentoid.toString() ?? '';
                                setValue('tipoMovilidad',setTipoMovilidadCaract(selectedDepartamento, selectedMunicipio));
                            }}
                            className="form-control">
                            <option value="">Seleccionar</option>
                            {(Array.isArray(municipiosdto) ? municipiosdto : []).map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.mun_municipio} - {option.dep_departamento}
                                </option>
                            ))}
                        </select>
                        {errors.municipioDesplazamiento && <p style={{ color: 'red' }}>Seleccione numero desplazamiento</p>}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="tipoEntorno">Tipo entorno del hecho:</label>
                        <select id="tipoEntorno" className="form-control" {...register('tipoEntorno', { required: true })}>
                            <option value="">Seleccionar</option>
                            {(Array.isArray(tiposlugar) ? tiposlugar : []).map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.tipTipolugar}
                                </option>
                            ))}
                        </select>
                        {errors.tipoEntorno && <p style={{ color: 'red' }}>Seleccione tipo entorno</p>}
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="tipoEntornoNombre">Nombre del Tipo de Entorno del hecho:</label>
                        <input id="tipoEntornoNombre" {...register('tipoEntornoNombre', { required: true })} className="form-control" placeholder="Tipo entorno" />
                        {errors.tipoEntornoNombre && <p style={{ color: 'red' }}>Digite tipo de entorno</p>}
                    </div>
                </div>
            </div>
            <div className="row">
                {watch('tipoHecho') === '3' && <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="tipoDesplazamiento">Tipo de Desplazamiento:</label>
                        <select 
                            id="tipoDesplazamiento" 
                            {...register('TipoDesplazamiento', {
                                required: watch('tipoHecho') === '3'
                            })} 
                            className="form-control">
                            <option value="">Seleccionar</option>
                            {(Array.isArray(tiposDesplazamiento) ? tiposDesplazamiento : []).map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.tipTipodesplazamiento}
                                </option>
                            ))}
                        </select>
                        {errors.TipoDesplazamiento && <p style={{ color: 'red' }}>Seleccione tipo desplazamiento</p>}
                    </div>
                </div>}
                <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="tipoMovilidad">Tipo Movilidad:</label>
                        <select 
                            id="tipoMovilidad" 
                            {...register('tipoMovilidad', { required: true })} 
                            className="form-control"
                            disabled>
                            <option value="">Seleccionar</option>
                            {(Array.isArray(tiposMovilidad) ? tiposMovilidad : []).map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.tipTipomovilidad}
                                </option>
                            ))}
                        </select>
                        {errors.tipoMovilidad && <p style={{ color: 'red' }}>Seleccione tipo movilidad</p>}
                    </div>
                </div>
            </div>
            <div className="row">
                {watch('tipoHecho') === '3' && <div className="col-md-6">
                    <div className="form-group">
                        <label htmlFor="causaDesplazamiento">Causa del Desplazamiento:</label>
                        <Select
                            id="causaDesplazamiento"
                            value={causasDesplazamientoSeleccionadas}
                            isMulti
                            name="causaDesplazamiento"
                            options={causasDesplazamiento}
                            onChange={ActualizarCausasDesplazamiento}
                            className="basic-multi-select"
                            classNamePrefix="Seleccione"
                        />
                        {errors.causaDesplazamiento && <p style={{ color: 'red' }}>Seleccione campos</p>}
                    </div>
                </div>}
                <div className="col-md-6">
                    <div className="form-group">
                        <label htmlFor="actorArmado">Qu&eacute; actor ocasiono el hecho:</label>
                        <Select
                            id="actorArmado"
                            value={responsableDesplazamientoSeleccionados}
                            isMulti
                            name="actorArmado"
                            options={responsableDesplazamiento}
                            onChange={ActualizarActoresArmados}
                            className="basic-multi-select"
                            classNamePrefix="Seleccione"
                        />
                        {errors.actorArmado && <p style={{ color: 'red' }}>Seleccione actor armado</p>}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="denuncioFiscalia">¿Denunci&oacute; en la fiscal&iacute;a lo que le paso?</label>
                        <select id="denuncioFiscalia" {...register('denuncioFiscalia', { required: true })} className="form-control">
                            <option value="">Seleccionar</option>
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                        {errors.denuncioFiscalia && <p style={{ color: 'red' }}>Seleccione respuesta</p>}
                    </div>
                </div>
            </div>
        </div>
    );
}

DesplazamientoForzado.propTypes = {
    register: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    control: PropTypes.object.isRequired,
    errors: PropTypes.object,
    forwardRef: PropTypes.any,
    numedesplazamientos: PropTypes.array,
    municipiosdto: PropTypes.array,
    tiposlugar: PropTypes.array,
    tiposDesplazamiento: PropTypes.array,
    tiposMovilidad: PropTypes.array,
    causasDesplazamiento: PropTypes.array,
    responsableDesplazamiento: PropTypes.array,
    causasDesplazamientoSeleccionadas: PropTypes.any,
    responsableDesplazamientoSeleccionados: PropTypes.any,
    ActualizarCausasDesplazamiento: PropTypes.func,
    ActualizarActoresArmados: PropTypes.func,
    hechosVictimizantes: PropTypes.array.isRequired,
};